import { RequestQueryBuilder, SCondition } from '@nestjsx/crud-request';

import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { TorchAPIConfiguration } from '../../../config/api.configuration';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Burly } from 'kb-burly';
import { ManyResponse } from '../../../responses/many.response';
import { EoQueryDataModel } from '../models/eo-analysis-data-query.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TorchEoQueryService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }


  public queryEos(pageSize: number = 15,
                  currentPage: number = 0,
                  sortDirection: 'ASC' | 'DESC' | '' = 'DESC',
                  sortBy: string = 'ACN',
                  filters: SCondition | null): Observable<ManyResponse<EoQueryDataModel>> {
    const qb = RequestQueryBuilder.create();
    qb.setPage(currentPage + 1).setLimit(pageSize);

    if (!!sortDirection && sortDirection != null) {
      qb.sortBy({field: sortBy, order: sortDirection});
    }
    if (!!filters) {
      qb.search(filters);
    }

    let finalURL;
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/mods/history-discrepancies')
      .appendRawQueryString(qb.query(false));

    finalURL = endpoint.get;

    return this.httpClient.get<ManyResponse<EoQueryDataModel>>(finalURL);
  }

  public getAtaList(eoNbr): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/mods/history-discrepancies')
      .addSegment('/ataList')
      .addSegment('/' + eoNbr)
      .get;

    return this.httpClient.get<[{ REPORTING_ATA: string }]>(endpoint).pipe(
      map(response => response.map(v => v.REPORTING_ATA))
    );
  }

  public getRevisionsCompliedWithList(eoNbr): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/mods/history-discrepancies')
      .addSegment('/revisionsCompliedWith')
      .addSegment('/' + eoNbr)
      .get;

    return this.httpClient.get<[{ REV_COMPLD_WITH: string }]>(endpoint).pipe(
      map(response => response.map(v => v.REV_COMPLD_WITH))
    );
  }
  public getMalfunctionCodesList(eoNbr): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/mods/history-discrepancies')
      .addSegment('/malfunctionCodes')
      .addSegment('/' + eoNbr)
      .get;

    return this.httpClient.get<[{ RECODED_MALFUNCTION_CD_DESC: string }]>(endpoint).pipe(
      map(response => response.map(v => v.RECODED_MALFUNCTION_CD_DESC))
    );
  }

  // public getAtaList(filters: SCondition | null):Observable<string[]> {
  //   const qb = RequestQueryBuilder.create();
  //   if(!!filters){
  //     qb.search(filters);
  //   }
  //   let finalURL;
  //   const endpoint = Burly(this.config.rootUrl)
  //     .addSegment('/mods/history-discrepancies')
  //     .addSegment('/ataList')
  //     .appendRawQueryString(qb.query(false));
  //   finalURL = endpoint.get
  //   return this.httpClient.get<string[]>(finalURL);
  // }

  public exportToExcel(queriedEo: EoQueryDataModel[]) {
    return new Observable(subscriber => {
      let endpoint = Burly(this.config.rootUrl)
        .addSegment('/mods/history-discrepancies')
        .addSegment('/export')
        .get;

      const httpOptions: { headers; observe; responseType; } = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        observe: 'response',
        responseType: 'blob'
      };

      const body = {
        queriedEo: queriedEo
      };

      this.httpClient.post(endpoint, body, httpOptions).subscribe((response) => {
        subscriber.next((response as unknown as HttpResponse<any>).body);
        subscriber.complete();
      });
    });
  }

//   public getFleets(contains): Observable<string[]> {
//     const endpoint = Burly(this.config.rootUrl)
//       .addSegment('/mods/history-discrepancies')
//       .addSegment('/fleets')
//       .addQuery('contains', contains)
//       .get;

//     return this.httpClient.get<[{ FLEET: string }]>(endpoint).pipe(
//       map(response => response.map(v => v.FLEET))
//     );
//   }

//   public getATAs(contains): Observable<string[]> {
//     const endpoint = Burly(this.config.rootUrl)
//       .addSegment('/mods/history-discrepancies')
//       .addSegment('/ATAs')
//       .addQuery('contains', contains)
//       .get;

//     return this.httpClient.get<[{ PRIMARY_ATA: string }]>(endpoint).pipe(
//       map(response => response.map(v => v.PRIMARY_ATA))
//     );
//   }

//   public getEoTypes(contains): Observable<string[]> {
//     const endpoint = Burly(this.config.rootUrl)
//       .addSegment('/mods/history-discrepancies')
//       .addSegment('/eoTypes')
//       .addQuery('contains', contains)
//       .get;

//     return this.httpClient.get<[{ EO_TYPE: string }]>(endpoint).pipe(
//       map(response => response.map(v => v.EO_TYPE))
//     );
//   }

//   public exportToExcel(trackedEos: EoModel[]) {
//     return new Observable(subscriber => {
//       let endpoint = Burly(this.config.rootUrl)
//         .addSegment('/mods/history-discrepancies')
//         .addSegment('/export')
//         .get;

//       const httpOptions: { headers; observe; responseType; } = {
//         headers: new HttpHeaders({
//           'Content-Type': 'application/json'
//         }),
//         observe: 'response',
//         responseType: 'blob'
//       };

//       const body = {
//         trackedEos: trackedEos
//       }
//       this.httpClient.post(endpoint, body, httpOptions).subscribe((response) => {
//         subscriber.next((response as unknown as HttpResponse<any>).body);
//         subscriber.complete();
//       });
//     });
//   }
}
